import { render, staticRenderFns } from "./card-box.vue?vue&type=template&id=630814e4&"
import script from "./card-box.vue?vue&type=script&lang=js&"
export * from "./card-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports